import { useCallback, useEffect, useState } from "react";
import { format, isValid } from "date-fns";
import { DATE_MONTH_YEAR_FORMAT } from "../DateTime.constants";
import {
  convertStringToDateObject,
  formatAsDateMonthYear,
} from "../utils/DateTime.utils";

export const useExpiryDateString = ({ open, initialDate }) => {
  const [dateString, setDateString] = useState("");

  useEffect(() => {
    if (!open) return;
    setDateString(formatAsDateMonthYear(initialDate));
  }, [open, initialDate]);

  const toPickerDate = useCallback(
    (value) =>
      value
        ? convertStringToDateObject({
            dateString: value,
            format: DATE_MONTH_YEAR_FORMAT,
          })
        : null,
    []
  );

  const handleDateChange = useCallback((date) => {
    if (!date || !isValid(date)) {
      setDateString("");
      return;
    }
    setDateString(format(date, DATE_MONTH_YEAR_FORMAT));
  }, []);

  return { dateString, setDateString, toPickerDate, handleDateChange };
};
